import { Link } from "react-router";

type TechnicalUserHelpPageProps = object;

export const TechnicalUserHelpPage: React.FC<
  TechnicalUserHelpPageProps
> = () => {
  return (
    <div className="container min-vh-80">
      <h3 className="page-caption mb-3">Technische Benutzer</h3>
      <div className="col-xxl-9 col-xl-9 col-lg-9 col-xs-9 mt-0 p-0">
        <p>
          Technische Benutzer dienen der Systemkommunikation zwischen anderen
          Anwendungen und der Sperrdatei und ermöglichen somit die
          Automatisierung von Prozessen, wie z.B. dem automatischen Download der
          Sperrdatei oder dem Sperren von Nummern. Im Gegensatz zu
          personenbezogenen Benutzerkonten verwenden technische Benutzer keine
          Passwörter, sondern <strong>Access Token</strong>.
        </p>
        <h5>Access Token für technische Benutzer</h5>
        <p>
          Technische Benutzer benötigen einen <strong>Access Token</strong> um
          auf die Sperrdatei zugreifen zu können. Aus technischen Gründen müssen
          technische Benutzer und Access Tokens in drei Schritten erstellt
          werden.
          <br />
          <dl className="mt-2">
            <dt>Schritt 1</dt>
            <dd>
              Erstellen des technischen Benutzers unter{" "}
              <Link to="/administration/institutes/edit">
                Institut bearbeiten
              </Link>
            </dd>

            <dt>Schritt 2</dt>
            <dd>
              Speichern des Instituts, damit der technische Benutzer im System
              erstellt wird.
            </dd>

            <dt>Schritt 3</dt>
            <dd>
              Erstellen des Access Token mit Klick auf den Technischen Benutzer
              unter{" "}
              <Link to="/administration/institutes/edit">
                Institut bearbeiten
              </Link>{" "}
              und anschließend auf die Schaltfläche{" "}
              <strong>Access Token erstellen</strong>.
            </dd>
          </dl>
        </p>
        <h6>Hinweise zu Access Token</h6>
        <ul>
          <li>
            Access Token werden nicht im System gespeichert und können nach der
            Erstellung nur einmalig angezeigt werden. Daher müssen die Access
            Token außerhalb der Sperrdatei sicher von Ihnen gespeichert werden.
          </li>
          <li>
            Access Token haben eine Gültigkeit von <strong>einem Jahr</strong>.
            Achten Sie daher darauf, sie rechtzeitig vor Ablauf ihrer Gültigkeit
            zu erneuern.
          </li>
          <li>
            {" "}
            Um den Austausch der Tokens zu vereinfachen, können technische
            Benutzer mehrere aktive Access Token besitzen.
          </li>
        </ul>
        <h6>Verwendung von Access Tokens</h6>
        <p>
          Access Token müssen über den HTTP-Header <i>x-session-token</i>{" "}
          gesetzt werden.
        </p>
        <strong>
          Exemplarischer Aufruf zum Download der aktuellen Sperrdatei
        </strong>
        <pre className="code-block bash-code">
          curl -X GET \ <br />
          -H &quot;x-session-token: [access-token]&quot; \<br />
          -o ~/Downloads/sperrdatei.zip \<br />
          https://sperrdatei.bik-gmbh.de/api/number/download
        </pre>
        <strong>
          Exemplarischer Aufruf zum Sperren von Nummern in der Sperrdatei
        </strong>
        <pre className="code-block bash-code">
          curl -X POST \<br />
          -H &quot;x-session-token: [access-token]&quot; \<br />
          -F &quot;file=@/path/to/file/nummern.csv;type=text/csv&quot; \<br />
          https://sperrdatei.bik-gmbh.de/api/number/upload
        </pre>
      </div>
    </div>
  );
};
